enum GROW2792_ACTIONS {
  PNP_REFRESH_TOGGLE_SWITCH = 'PNP_REFRESH_TOGGLE_SWITCH',
  PNP_REFRESH_RESET_TOGGLE_SWITCH = 'PNP_REFRESH_RESET_TOGGLE_SWITCH',
  PNP_REFRESH_CHANGE_USERS = 'PNP_REFRESH_CHANGE_USERS',
}

export default GROW2792_ACTIONS;
